import React, { useState, useRef } from "react";
import axios from "../../../axiosInstance";
import Sidebar from "../Sidebar/Sidebar";
import "./AddNews.css";
import AdsBanner from "../../AdsBanner/AdsBanner";

function AddNews() {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [shortDescription, setShortDescription] = useState("");
  const [image, setImage] = useState(null);
  const [category, setCategory] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [activeFormats, setActiveFormats] = useState({
    bold: false,
    italic: false,
    underline: false,
    fontSize: null,
  });

  const descriptionRef = useRef(null);
  const categories = [
    "breaking-news",
    "live",
    "entertainment",
    "cinema",
    "sports",
    "astrology",
    "devotional",
    "jobs",
    "others",
  ];
  const reporterId = localStorage.getItem("reporterId");

  // ✅ Toggle Text Formatting and Set Active State
  const applyFormat = (command) => {
    document.execCommand(command, false, null);
    setDescription(descriptionRef.current.innerHTML);
    setActiveFormats((prev) => ({ ...prev, [command]: !prev[command] }));
  };

  // ✅ Change Font Size and Highlight Active Button
  const changeTextSize = (size) => {
    document.execCommand("fontSize", false, size);
    setDescription(descriptionRef.current.innerHTML);
    setActiveFormats((prev) => ({ ...prev, fontSize: size }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!description) {
      setMessage("Description is required.");
      setMessageType("error");
      return;
    }
    setLoading(true);
    setMessage("");
    setMessageType("");
    try {
      const formData = new FormData();
      formData.append("title", title);
      formData.append("description", description);
      formData.append("shortDescription", shortDescription);
      formData.append("image", image);
      formData.append("category", category);
      formData.append("reporterId", reporterId);

      const token = localStorage.getItem("sessiontoken");
      await axios.post("/api/news/add-news", formData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setMessage("News added successfully!");
      setMessageType("success");
      resetForm();
    } catch (error) {
      setMessage("Error adding news. Please try again.");
      setMessageType("error");
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setTitle("");
    setDescription("");
    setShortDescription("");
    setImage(null);
    setCategory("");
    setActiveFormats({ bold: false, italic: false, underline: false, fontSize: null });
    if (descriptionRef.current) {
      descriptionRef.current.innerHTML = "";
    }
  };

  return (
    <div>
      <Sidebar />
      <div className="addnews-container">
        <div className="addnews-content">
          <AdsBanner placement="Header" page="News" />
          <h2 className="addnews-title">Post News</h2>
          {message && (
            <div className={`addnews-message addnews-${messageType}`}>
              {message}
            </div>
          )}
          <form onSubmit={handleSubmit} className="addnews-form">
            <div className="addnews-form-group">
              <label className="addnews-label">Title:</label>
              <input
                type="text"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                required
                className="addnews-input"
              />
            </div>

            <div className="addnews-form-group">
              <label className="addnews-label">Short Description:</label>
              <input
                type="text"
                value={shortDescription}
                onChange={(e) => setShortDescription(e.target.value)}
                required
                className="addnews-input"
              />
            </div>

            <div className="addnews-form-group">
              <label className="addnews-label">Description:</label>
              <div className="text-toolbar">
                <button
                  type="button"
                  onClick={() => applyFormat("bold")}
                  className={`format-button ${activeFormats.bold ? "active" : ""}`}
                >
                  <b>B</b>
                </button>
                <button
                  type="button"
                  onClick={() => applyFormat("italic")}
                  className={`format-button ${activeFormats.italic ? "active" : ""}`}
                >
                  <i>I</i>
                </button>
                <button
                  type="button"
                  onClick={() => applyFormat("underline")}
                  className={`format-button ${activeFormats.underline ? "active" : ""}`}
                >
                  <u>U</u>
                </button>

                <button
                  type="button"
                  onClick={() => changeTextSize(3)}
                  className={`format-button ${activeFormats.fontSize === 3 ? "active" : ""}`}
                >
                  Small
                </button>
                <button
                  type="button"
                  onClick={() => changeTextSize(5)}
                  className={`format-button ${activeFormats.fontSize === 5 ? "active" : ""}`}
                >
                  Medium
                </button>
                <button
                  type="button"
                  onClick={() => changeTextSize(7)}
                  className={`format-button ${activeFormats.fontSize === 7 ? "active" : ""}`}
                >
                  Large
                </button>
              </div>

              <div
                contentEditable
                ref={descriptionRef}
                onInput={() => setDescription(descriptionRef.current.innerHTML)}
                className="addnews-textarea"
                style={{
                  border: "1px solid #ccc",
                  padding: "10px",
                  minHeight: "100px",
                  fontSize: "16px",
                  outline: "none",
                  cursor: "text",
                }}
              ></div>
            </div>

            <div className="addnews-form-group">
              <label className="addnews-label">Image:</label>
              <input
                type="file"
                onChange={(e) => setImage(e.target.files[0])}
                required
                className="addnews-input"
              />
            </div>

            <div className="addnews-form-group">
              <label className="addnews-label">Category:</label>
              <select
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                required
                className="addnews-select"
              >
                <option value="">Select Category</option>
                {categories.map((cat, index) => (
                  <option key={index} value={cat}>
                    {cat}
                  </option>
                ))}
              </select>
            </div>

            <button type="submit" disabled={loading} className="addnews-button">
              {loading ? "Submitting..." : "Submit News"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AddNews;
